import Vue from 'vue';
import Subtitle from './Subtitle.vue';
import SvgIcon from '../../common/Icon.vue';
Vue.component('svg-icon', SvgIcon);

export default (props) => {
  const Constructor = Vue.extend(Subtitle);
  const component = new Constructor({
    propsData: props,
    data: {
      value: props.text || ''
    }
  });
  return { component };
};
